import React from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-haiku';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';
import { useAppStore } from 'store/useAppStore';

const Page = ({ page }) => {
	// Check if viewing from mobile
	const isMobile = useMediaQuery('(max-width: 768px)');

	// Use app's store
	const [section, setNavigation] = useAppStore(state => [state.section, state.setNavigation]);

	// Concat page's className
	const cls = classnames(
		'h-7 my-2 px-4 flex items-center text-neutral-800 hover:text-amber-500 dark:hover:text-amber-500 border-l-4 transition-all',
		'dark:text-neutral-400',
		page.url !== section && 'border-transparent',
		page.url === section && 'text-amber-500 border-amber-500 dark:text-amber-500'
	);

	// Concat icon's className
	const iconClassName = classnames(
		'mr-4 text-2xl text-neutral-400',
		'dark:text-neutral-600',
		page.url === section && 'text-amber-500 dark:text-amber-500'
	);

	// Handle click on navigation links
	const onClick = () => {
		if (isMobile) setNavigation(false);
	};

	if (page.url) {
		return (
			<Link
				to={page.url}
				className={cls}
				onClick={onClick}
			>
				<Icon icon={page.icon} className={iconClassName} />
				{page.text}
			</Link>
		);
	} else {
		return (
			<div className="h-7 my-2 px-4 flex items-center font-bold text-neutral-500 transition-all">
				{page.text}
			</div>
		);
	}
};

export default Page;